/**
 * Created by SJ on 11/30/16.
 */
// export const API_ROOT = (process.env.NODE_ENV === 'production')
//   ? 'https://need to be set/'
//   : 'http://localhost:8888/'
//
// export const CookieDomain = (process.env.NODE_ENV === 'production')
//   ? ''
//   : ''
let configs = {
  hostImg: 'http://localhost:8000/uploads/',
  hostPrime: '' //  开发与生产环境切换
}
// if (process.env.NODE_ENV === 'production') {
//   configs = window.__configs // 在config.js中设置的
// }
export default configs



// WEBPACK FOOTER //
// ./src/config.js